import React from 'react'
import PropTypes from 'prop-types'
import InfoButton from '../buttons/InfoButton'

const renderSliderInput = ({ display, input, label, min, max, step, tipContent }) => (
  <div>
    {label &&
    <div>
      <label>{label}</label>
      <span className="pull-right" style={{color: '#808080'}}>
        {display}&nbsp;
        {tipContent && <InfoButton content={tipContent}/>}
      </span>
    </div>}
    <input type="range" min={min} max={max} step={step} value={Number(input.value)} onChange={input.onChange} style={{width: '100%'}} />
  </div>
)

renderSliderInput.propTypes = {
  display: PropTypes.string,
  input: PropTypes.any.isRequired,
  label: PropTypes.string,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  tipContent: PropTypes.string,
}

renderSliderInput.defaultProps = {
  display: '',
}

export default renderSliderInput



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderSliderInput.js